import type { FetchError } from 'ofetch';
import type { LookUpAddress } from '@/types/address';
import type { HttpClient, HttpResponse } from '@/utils/HttpClient';
import { StoreLocation } from '~/types/store';

export const LocationService = (httpClient: HttpClient) => ({
  async getLocations(queryParams = {}): Promise<HttpResponse<StoreLocation[], FetchError>> {
    const params = new URLSearchParams({ ...queryParams });
    const { data, error } = await httpClient<StoreLocation[], FetchError>({ endpoint: `/locations?${params}` });
    if (error) return { error };
    const sortedLocations = (data || []).sort((a, b) => {
      const textA = a.name;
      const textB = b.name;
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    return { data: sortedLocations };
  },
  searchAddresses(query: string): Promise<HttpResponse<LookUpAddress[], FetchError>> {
    return httpClient<LookUpAddress[], FetchError>({
      endpoint: '/locations/addresses/search',
      method: 'POST',
      body: { query },
    });
  },
});
